module.exports = __webpack_public_path__ + "img/118.fecd0039.webp";